import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IntlModule } from '@progress/kendo-angular-intl';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { TreeViewModule } from '@progress/kendo-angular-treeview';

import { SchedulerNavigationModule } from '../shared/kendo-scheduler-navigation/scheduler-navigation.module';
import { SupporterViewComponent } from './supporter-view.component';
import { AvailabilityViewComponent } from './availability-view/availability-view.component';
import { SchedulerViewComponent } from './scheduler-view/scheduler-view.component';
import { SchedulerContentComponent } from './scheduler-view/scheduler/scheduler-content.component';
import { FiltersBarComponent } from './scheduler-view/filters-bar/filters-bar.component';
import { SupporterDataComponent } from './availability-view/supporter-data/supporter-data.component';
import { EditMeetingViewComponent } from './scheduler-view/scheduler/edit-meeting-view/edit-meeting-view.component';

import { AvailabilityViewService } from './availability-view/availability-view.service';
import { SchedulerViewService } from './scheduler-view/scheduler-view.service';

import { CanDeactivateGuard } from '../can-deactivate.guard';
import { TranslationModule } from '../shared/translation/translation.module';
import { AddRecurrenceModalComponent } from './availability-view/add-recurrence-modal/add-recurrence-modal.component';

@NgModule({
  declarations: [
    SupporterViewComponent,
    AvailabilityViewComponent,
    SchedulerViewComponent,
    SchedulerContentComponent,
    FiltersBarComponent,
    SupporterDataComponent,
    EditMeetingViewComponent,
    AddRecurrenceModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    SchedulerModule,
    ButtonsModule,
    IntlModule,
    DropDownsModule,
    DialogModule,
    SchedulerNavigationModule,
    TreeViewModule,
    TranslationModule
  ],
  providers: [
    AvailabilityViewService,
    CanDeactivateGuard,
    SchedulerViewService
  ],
  entryComponents: [
    EditMeetingViewComponent
  ]
})
export class SupporterViewModule { }
